// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".RegularTelephone-module-control-2-OUl{display:flex;gap:var(--des-dimension-gap-and-padding-field-vertical-padding);width:100%}[dir=rtl] .RegularTelephone-module-control-2-OUl{flex-direction:row-reverse;justify-content:flex-end}.RegularTelephone-module-code-3jxOw{min-width:115px}.RegularTelephone-module-phoneSelectBlock-3FIGc{display:flex}.RegularTelephone-module-telephoneFullWidth-3hift{width:100%}.RegularTelephone-module-phoneContainer-rX8dd{width:100%;display:flex;flex-direction:column;align-items:flex-start;gap:var(--des-dimension-gap-and-padding-field-between-label-and-box)}", ""]);
// Exports
exports.locals = {
	"control": "RegularTelephone-module-control-2-OUl",
	"code": "RegularTelephone-module-code-3jxOw",
	"phoneSelectBlock": "RegularTelephone-module-phoneSelectBlock-3FIGc",
	"telephoneFullWidth": "RegularTelephone-module-telephoneFullWidth-3hift",
	"phoneContainer": "RegularTelephone-module-phoneContainer-rX8dd"
};
module.exports = exports;
